<script>
  import { onMount, afterUpdate } from "svelte";
  import { slide } from "svelte/transition";
  import Card, { PrimaryAction, Content } from "@smui/card";
  import Select, { Option } from "@smui/select";
  import { Textfield } from "../components";
  import HelperText from "@smui/select/helper-text/index";
  import Button, { Label, Icon } from "@smui/button";
  import IconButton from "@smui/icon-button";

  import { apiGet, apiUpdate, apiCreate, apiDelete } from "../httpCommon";

  export let venueId;
  let venueDiscounts;

  let showAdd = false;
  let working = false;
  let newDiscount = null;
  let newErr = null;

  async function getDiscountData() {
    try {
      venueDiscounts = await apiGet(`/venues/${venueId}/discounts`);
    } catch (error) {}
  }

  function add() {
    if (newDiscount === null) {
      newDiscount = {
        discount_code: "",
        discount_type: "FIXED_PERCENTAGE"
      };
      newErr = {};
    }
  }

  function cancel() {
    newDiscount = null;
  }

  async function create() {
    try {
      working = true;
      newErr = {};
      venueDiscounts = await apiCreate(
        `/venues/${venueId}/discounts`,
        newDiscount
      );
      newDiscount = null;
    } catch (error) {
      if (error.errors) {
        newErr = error.errors;
      }
    } finally {
      working = false;
    }
  }

  async function deleteDiscount(id) {
    try {
      working = true;
      venueDiscounts = await apiDelete(`/venues/${venueId}/discounts`, id);
    } catch (error) {
    } finally {
      working = false;
    }
  }

  onMount(async () => {
    getDiscountData();
  });
</script>

<style>
  .title {
    display: flex;
    justify-content: space-between;
  }
  .body {
    display: table;
  }
  .header-row {
    display: table-header-group;
    font-weight: 600;
  }
  .row {
    display: table-row;
    justify-content: space-between;
    align-items: baseline;
  }
  .cell {
    display: table-cell;
    white-space: nowrap;
  }
  .new-header {
    display: flex;
    justify-content: space-between;
  }
  .new {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
</style>

{(console.log(`newDiscount: ${newDiscount}`), '')}
<Card variant="outlined" padded color="error">
  <span class="title">
    <h3>Discount Vouchers</h3>
    <IconButton class="material-icons" disabled={newDiscount || working} on:click={add}>
      add
    </IconButton>
  </span>
  {#if venueDiscounts}
    <div class="body">
      {#if venueDiscounts.length}
        <div class="header-row">
          <span class="cell">Voucher Code</span>
          <span class="cell">Discount</span>
          <span class="cell" />
        </div>
      {:else if !newDiscount}
        <span>No discounts setup</span>
      {/if}
      {#each venueDiscounts as row, i}
        <div class="row" transition:slide|local>
          <span class="cell">{row.discount_code}</span>
          <span class="cell">
            {#if row.discount_type == 'FIXED_AMOUNT'}
              &pound;{row.discount_value}
            {:else if row.discount_type == 'FIXED_PERCENTAGE'}
              {row.discount_value}%
            {/if}
          </span>
          <span class="cell">
            <Button on:click={() => deleteDiscount(row.id)} disabled={working}>
              <Label>remove</Label>
            </Button>
          </span>
        </div>
      {/each}
    </div>
    {#if newDiscount}
      <div in:slide|local>
        <Card padded variant="outlined">
          <div class="new-header">
            <h4>Create new discount</h4>
            <span>
              <IconButton class="material-icons" on:click={create} disabled={working}>
                save
              </IconButton>
              <IconButton class="material-icons" on:click={cancel} disabled={working}>
                close
              </IconButton>
              <span />
            </span>
          </div>
          <div class="new">
            <Textfield
              class="short"
              bind:value={newDiscount.discount_code}
              error={newErr.discount_code}
              label="Code" />
            <Textfield
              type="number"
              class="number"
              bind:value={newDiscount.discount_value}
              error={newErr.discount_value}
              label="Value" />
            &nbsp;
            <Select bind:value={newDiscount.discount_type}>
              <Option value="FIXED_PERCENTAGE" selected>%</Option>
              <Option value="FIXED_AMOUNT">£</Option>
            </Select>
          </div>
        </Card>
      </div>
    {/if}
  {:else}Loading discounts{/if}
</Card>
